const ossUrl = import.meta.env.VITE_GLOB_OSS_BASE_URL || 'https://electronic-color-card-test-dev.oss-cn-shenzhen.aliyuncs.com';
export const OSSImgUrl = (url) => {
  if (url) {
    if (url.startsWith('https://') || url.startsWith('http://')) {
      return url;
    }
    return `${ossUrl}/${url}`;
  }
};

export const isMobile = () => {
  if (typeof window === 'undefined') return false;
  // 判断 userAgent 和 屏幕宽度
  const isUserAgentMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
  const isMaxWidthMobile = window.innerWidth <= 768;

  console.log('isMobile', isUserAgentMobile, isMaxWidthMobile);
  
  return isUserAgentMobile || isMaxWidthMobile;
};

export const isPC = () => {
  return !isMobile();
};
